import React, { useContext, useEffect } from "react";
import './theOutlet.style.scss';
import { AccountContext } from "../../../Contexts/main.context";
import ReadOnlyClientView from "../../DisplayBox/AccountManager/ViewClient/viewClient.component";
import EditClient from "../../DisplayBox/AdminOnly/EditClient/editClient.component";
import '../../../assets/CSS/bootstrap-5-48-LGO.css';
import ClientLocations from "../../DisplayBox/AccountManager/Locations/locations.component";
import CitationsList from "../../DisplayBox/AdminOnly/ViewCitations/showLocation.component";
import CitationUploader from "../../DisplayBox/AdminOnly/UploadCitation/uploadCitation.component";
import ManageUsers from "../../DisplayBox/AdminOnly/ManageUsers/ManageUsers.component";
import CreateCitations from "../../DisplayBox/AdminOnly/CreateCitations/createCitations.component";
import CreateUser from "../../DisplayBox/AdminOnly/CreateUser/CreateUser.component";
import UpdateUser from "../../DisplayBox/AdminOnly/UpdateUser/UpdateUser.component";
import EditMyAccount from "../../DisplayBox/AccountManager/MyAccount/MyAccount.component";
import ManageClients from "../../DisplayBox/AdminOnly/ManageClients/ManageClients.component";
import CreateClient from "../../DisplayBox/AdminOnly/CreateClient/CreateClient.component";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";


const TheOutlet = () => {
     const { activeOutlet, activeClient, userEditAccount, myAccount,updateMyAccount } = useContext(AccountContext);
     const navigate = useNavigate();

     useEffect(() => {

       if (myAccount && myAccount.length > 0) {
               console.log('found account');
          } else {
               const token = localStorage.getItem('LGOUser');
               if (token && typeof token === 'string') {
                    try {
                         const decoded = jwtDecode(token);
                         const currentTime = Math.floor(Date.now() / 1000);

                         if (decoded.exp && decoded.exp > currentTime) {
                              updateMyAccount(decoded);
                         } else {
                              localStorage.removeItem('LGOUser');
                              navigate('/login');
                         }
                    } catch (err) {
                         localStorage.removeItem('LGOUser');
                         navigate('/login');
                    }
               } else {
                    navigate('/login');
               }
          }
     }, []);


     const renderOutlet = () => {
          // 🔒 Guard clause: Wait for activeClient to be defined and not null
          if (!activeClient) return null;
          if (typeof activeOutlet === "string") {
               switch (activeOutlet) {
                    case 'editCustomer':
                         return <EditClient clientData={activeClient} />;
                    case 'ViewCustomer':
                         return <ReadOnlyClientView client={activeClient} />;
                    case 'ViewLocation':
                         return <ClientLocations />;
                    case 'ViewCitations':
                         return <CitationsList />;
                    case 'AddCitation':
                         return <CitationUploader />
                    case 'createCitation':
                         return <CreateCitations />
                    case 'Users':
                         return <ManageUsers />
                    case 'createUser':
                         return <CreateUser />
                    case 'updateUser':
                         return <UpdateUser user={userEditAccount} />
                    case 'CreateClient':
                         return <CreateClient />
                    case 'Clients':
                         return <ManageClients />
                    case 'EditAccount':
                         return <EditMyAccount />
                    default:
                         return <ClientLocations />;
               }
          }

          return null;
     };

     return (
          <div id="theOutlet" style={{ zIndex: "2000" }}>
               {renderOutlet()}
          </div>
     );
};

export default TheOutlet;
